import { render } from 'nunjucks'

import { Templates } from '../constants'

import { setHtml } from '../utils'

export function Render (match, template) {

    const content = document.querySelector('#content')

    try {

      setHtml(content, render(`${template}.html`))

    } catch (exception) {

      setHtml(content, Templates.ERROR_LOAD_TEMPLATE)
    }
}